import { fadedButtonStyle, filledButtonStyle, largeButtonStyle, smallButtonStyle } from "@/data/styles"

export type ButtonSize = 'small' | 'large'
export type ButtonVariant = 'filled' | 'faded'

export const sizeStyles: Record<ButtonSize, string> = {
  small: smallButtonStyle,
  large: largeButtonStyle
}

export const variantStyles: Record<ButtonVariant, string> = {
  filled: filledButtonStyle,
  faded: fadedButtonStyle,
}